module.exports = __webpack_public_path__ + "img/ic-minus-gray.eaa01b4e.svg";